var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","text":""},on:{"click":_vm.copyURL}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("content_copy")]),_vm._v(" Share link ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }